module.exports = __webpack_public_path__ + "fonts/Goldney-Regular.efd2dbd.otf";